export const treeList = _this => [
  // 请假
  {
    label: _this.$t('81'),
    id: 1,
    children: [
      {
        label: _this.$t('765'),
        isLeaf: true,
        id: 2,
        comp: () => import('./holiday-rule')
      },
      {
        label: _this.$t('110'),
        isLeaf: true,
        id: 3,
        comp: () => import('./holiday-rest')
      }
    ]
  },
  // 加班
  {
    label: _this.$t('84'),
    id: 5,
    children: [
      {
        label: _this.$t('112'),
        isLeaf: true,
        id: 6,
        comp: () => import('./ot-rule')
      }
    ]
  },
  // 补卡
  {
    label: _this.$t('83'),
    id: 8,
    children: [
      {
        label: _this.$t('113'),
        isLeaf: true,
        id: 9,
        comp: () => import('./sup-card')
      }
    ]
  }
  // 出差
  // {
  //   label: _this.$t('86'),
  //   id: 11,
  //   children: [
  //     {
  //       label: _this.$t('1600'),
  //       isLeaf: true,
  //       id: 15,
  //       comp: () => import('./travel-rule')
  //     }
  //   ]
  // }
]
